/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Events_SelectedInputs */

const en_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Events are selected. Please select one or more Events first`)
};

const fr_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement sélectionné. Veuillez sélectionner un ou plusieurs événements d'abord`)
};

const de_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind keine Veranstaltungen ausgewählt. Bitte wählen Sie zuerst eine oder mehrere Veranstaltungen aus.`)
};

const it_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato. Seleziona prima uno o più eventi`)
};

const ru_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятия не выбраны. Пожалуйста, сначала выберите одно или несколько мероприятий.`)
};

const es_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos seleccionados. Seleccione uno o más eventos primero.`)
};

const zh_cn2_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何活动。请先选择一个或多个活动。`)
};

const ja_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントが選択されていません。まず1つ以上のイベントを選択してください。`)
};

const hi_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट चयनित नहीं है। कृपया पहले एक या अधिक इवेंट चुनें।`)
};

const pt_pt2_no_events_selected = /** @type {(inputs: No_Events_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento foi selecionado. Selecione um ou mais eventos primeiro.`)
};

/**
* | output |
* | --- |
* | "No Events are selected. Please select one or more Events first" |
*
* @param {No_Events_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_events_selected = /** @type {((inputs?: No_Events_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Events_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_events_selected(inputs)
	if (locale === "de") return de_no_events_selected(inputs)
	if (locale === "it") return it_no_events_selected(inputs)
	if (locale === "ru") return ru_no_events_selected(inputs)
	if (locale === "es") return es_no_events_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_no_events_selected(inputs)
	if (locale === "ja") return ja_no_events_selected(inputs)
	if (locale === "hi") return hi_no_events_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_no_events_selected(inputs)
	return en_no_events_selected(inputs)
});